import {Injectable} from '@angular/core';
import {SyncService} from '../OffService/sync.service';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';
import {RequestHandler} from '../OffService/request-handler';
import { AnalisisModel } from 'src/app/models/analisis/analisis.model';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';

@Injectable({
    providedIn: 'root'
})
export class AnalisisApiService {

    public analisis = {
        GET: new RequestHandler<AnalisisModel[]>(),
        POST: new RequestHandler<AnalisisModel[]>(),
        PUT: new RequestHandler<AnalisisModel[]>(),
        DELETE: new RequestHandler<AnalisisModel>()
    };

    public comunidadesRegantes = {
        GET: new RequestHandler<ComunidadesRegantesModel[]>(),
        POST: new RequestHandler<ComunidadesRegantesModel[]>(),
        PUT: new RequestHandler<ComunidadesRegantesModel[]>(),
        DELETE: new RequestHandler<ComunidadesRegantesModel[]>()
    }


    constructor(
        private syncService: SyncService<AnalisisModel[]>,
        private syncServiceDeletee: SyncService<AnalisisModel>,
        private api: ApiRequestService<AnalisisModel[]>,
        private apiDelete: ApiRequestService<AnalisisModel>,
        private apiComunidadesRegantes: ApiRequestService<ComunidadesRegantesModel[]>,
        private apiDeleteComunidadesRegantes: ApiRequestService<ComunidadesRegantesModel[]>,
        private syncServiceComunidadesRegantes: SyncService<ComunidadesRegantesModel[]>,
        private syncServiceDeleteComunidadesRegantes: SyncService<ComunidadesRegantesModel[]>
    ) {

        this.defineAnalisis();
        this.defineComunidadesRegantes();
    }

    private defineAnalisis() {
        this.analisis.GET.fetch(HttpRequestType.GET, 'analisis/get');
        this.analisis.POST.fetch(HttpRequestType.POST, 'analisis/post');
        this.analisis.PUT.fetch(HttpRequestType.PUT, 'generic/analisis');
        this.analisis.DELETE.fetch(HttpRequestType.DELETE, 'generic/analisis');

        this.api.registerRequest(this.analisis.GET);
        this.api.registerRequest(this.analisis.POST);
        this.api.registerRequest(this.analisis.PUT);
        this.apiDelete.registerRequest(this.analisis.DELETE);

        this.syncService.register(this.syncService.baseSyncPolicy(this.analisis.GET));
        this.syncService.register(this.syncService.baseSyncPolicy(this.analisis.POST));
        this.syncService.register(this.syncService.baseSyncPolicy(this.analisis.PUT));
        this.syncServiceDeletee.register(this.syncServiceDeletee.baseSyncPolicy(this.analisis.DELETE));
    }

    defineComunidadesRegantes(){
        this.comunidadesRegantes.GET.fetch(HttpRequestType.GET, 'analisis/comunidadesRegantes');
        this.comunidadesRegantes.POST.fetch(HttpRequestType.POST, 'analisis/comunidadesRegantes');
        this.comunidadesRegantes.PUT.fetch(HttpRequestType.PUT, 'generic/comunidades_regantes');
        this.comunidadesRegantes.DELETE.fetch(HttpRequestType.DELETE, 'generic/comunidades_regantes');

        this.apiComunidadesRegantes.registerRequest(this.comunidadesRegantes.GET);
        this.apiComunidadesRegantes.registerRequest(this.comunidadesRegantes.POST);
        this.apiComunidadesRegantes.registerRequest(this.comunidadesRegantes.PUT);
        this.apiDeleteComunidadesRegantes.registerRequest(this.comunidadesRegantes.DELETE);

        this.syncServiceComunidadesRegantes.register(this.syncServiceComunidadesRegantes.baseSyncPolicy(this.comunidadesRegantes.GET));
        this.syncServiceComunidadesRegantes.register(this.syncServiceComunidadesRegantes.baseSyncPolicy(this.comunidadesRegantes.POST));
        this.syncServiceComunidadesRegantes.register(this.syncServiceComunidadesRegantes.baseSyncPolicy(this.comunidadesRegantes.PUT));
        this.syncServiceDeleteComunidadesRegantes.register(this.syncServiceDeleteComunidadesRegantes.baseSyncPolicy(this.comunidadesRegantes.DELETE));
    }
}
